/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How a user reached a route — a first paint, or an in-app navigation.
 * @export
 */
export const RouteEntryMethod = {
    direct: 'direct',
    navigation: 'navigation'
} as const;
export type RouteEntryMethod = typeof RouteEntryMethod[keyof typeof RouteEntryMethod];


export function instanceOfRouteEntryMethod(value: any): boolean {
    for (const key in RouteEntryMethod) {
        if (Object.prototype.hasOwnProperty.call(RouteEntryMethod, key)) {
            if (RouteEntryMethod[key as keyof typeof RouteEntryMethod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RouteEntryMethodFromJSON(json: any): RouteEntryMethod {
    return RouteEntryMethodFromJSONTyped(json, false);
}

export function RouteEntryMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): RouteEntryMethod {
    return json as RouteEntryMethod;
}

export function RouteEntryMethodToJSON(value?: RouteEntryMethod | null): any {
    return value as any;
}

export function RouteEntryMethodToJSONTyped(value: any, ignoreDiscriminator: boolean): RouteEntryMethod {
    return value as RouteEntryMethod;
}

